import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Grid,
  Container,
  Stepper,
  Step,
  StepLabel,
  LinearProgress,
  FormControlLabel,
  Checkbox,
  Divider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ThemeProvider,
  Paper,
  createTheme,
  Tooltip,
  IconButton,
  Alert,
  Stack,
  Autocomplete,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import { addXML } from "../redux/actions/productAction";
import { useDispatch, useSelector } from "react-redux";
import { addProductProvider, fetchProvider } from "../redux/actions/xmlAction";
import useAlert from "../hooks/useAlert";
import { validateXMLAdd } from "../utils/validation";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IoMdSave } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../config/appConfig";

//imput alanları daha sonra düzenlenecek
export const XmlProductSourceAddPage = () => {
  const dispatch = useDispatch();
  const { showErrorAlertXMLAdd, showSuccessAlertXMLAdd } = useAlert();
  const getProviders = async () => {
    try {
      await dispatch(fetchProvider());
    } catch {}
  };
  useEffect(() => {
    getProviders();
  }, []);
  const providers = useSelector((state) => state?.providers?.providers || []);
  const [productProvider, setProductProvider] = useState({
    productProviderGeneralSetting: {},
  });
  const [productProviderGeneralSetting, setProductProviderGeneralSetting] =
    useState({
      newBarcode: false,
      stokUpdate: true,
      priceUpdate: false,
    });
  const [productProviderPriceSetting, setProductProviderPriceSetting] =
    useState({});
  const [formErrors, setFormErrors] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [vatConfig, setVatConfig] = useState(false);
  const steps = [
    "Tanımlama Bilgileri",
    "Ürün Ayarları",
    "Fiyat Ayarları",
    "Onay",
  ];
  const navigate = useNavigate();

  const handleNext = () => {
    productProviderGeneralSetting.manuelVatRate =
      productProviderGeneralSetting.vatRate == null ? false : true;
    productProvider.productProviderGeneralSetting =
      productProviderGeneralSetting;
    productProvider.userId = authUserId;
    const errors = validateXMLAdd(productProvider, activeStep);
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const handleSubmit = async () => {
    try {
      productProviderGeneralSetting.manuelVatRate =
        productProviderGeneralSetting.vatRate == null ? false : true;
      productProvider.productProviderGeneralSetting =
        productProviderGeneralSetting;
      productProvider.userId = authUserId;
      productProvider.state = 1;
      productProvider.ia = true;
      productProvider.productProviderGeneralSetting.ia = true;
      const errors = validateXMLAdd(productProvider, activeStep);
      setFormErrors(errors);

      if (Object.keys(errors).length > 0) return;
      await dispatch(addProductProvider(productProvider));
      showSuccessAlertXMLAdd();
    } catch {
      showErrorAlertXMLAdd();
    }
  };

  const handleChange = (event) => {
    const selectedProvider = providers.find(
      (provider) => provider.id === event.target.value
    );
    setProductProvider((prev) => ({
      ...prev,
      providerId: selectedProvider?.id || null,
      name: selectedProvider?.name || "",
    }));
  };
  const handleInputChange = (field, value) => {
    setProductProvider((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleInputChangeProductProviderGeneralSetting = (field, value) => {
    setProductProviderGeneralSetting((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // const handleInputChangeProductProviderPriceSetting = (field, value) => {
  //   setProductProviderPriceSetting((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  const Section = ({ title, children }) => (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h6"
        sx={{ mb: 2, color: "primary.main", fontWeight: "bold" }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
  const theme = createTheme({
    palette: {
      primary: {
        main: blue[700],
        light: blue[400],
        dark: blue[900],
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            minWidth: "180px",
            minHeight: "50px",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            padding: "24px",
          },
        },
      },
    },
  });
  const ToggleButton = ({ selected, onClick, children }) => (
    <Button
      variant={selected ? "contained" : "outlined"}
      onClick={onClick}
      sx={{
        borderRadius: 1,
        borderWidth: "2px",
        "&:hover": {
          borderWidth: "2px",
        },
      }}
    >
      {children}
    </Button>
  );

  const renderBooleanValue = (value) => (
    <Typography
      component="span"
      color={value ? "success.main" : "text.secondary"}
      fontWeight="medium"
    >
      {value ? "Evet" : "Hayır"}
    </Typography>
  );

  // Add navigation handlers for the final step buttons
  const handleGoHome = () => {
    navigate("/");
  };
  const handleAddNewSource = () => {
    navigate("/XmlProductSourceAddPage");
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 1, sm: 2, md: 4 },
        pt: { xs: 6, sm: 7, md: 8 },
      }}
    >
      <Container maxWidth={false}>
        <Card
          sx={{
            p: { xs: 2, sm: 3, md: 4 },
            minHeight: { xs: "auto", sm: 500 },
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              sx={{
                mt: { xs: 2, sm: 3, md: 4 },
                mb: { xs: 3, sm: 4, md: 6 },
                "& .MuiStepLabel-root .Mui-completed": {
                  color: "success.main",
                },
                "& .MuiStepLabel-root .Mui-active": { color: "primary.main" },
                "& .MuiStepLabel-label": {
                  fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                  fontWeight: 500,
                  whiteSpace: "pre-line",
                  textAlign: "center",
                },
                "& .MuiStepConnector-root": {
                  minHeight: { xs: 16, sm: 24 },
                },
                "& .MuiStepIcon-root": {
                  fontSize: { xs: 18, sm: 24, md: 28 },
                },
              }}
            >
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {activeStep === 0 && (
              <>
                <Alert
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  }}
                  severity="info"
                >
                  XML Kaynağınız yok ise talep oluşturunuz.
                </Alert>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    textAlign: "left",
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  }}
                >
                  TANIMLAMA BİLGİLERİ
                </Typography>
                <Autocomplete
                  fullWidth
                  size="small"
                  options={providers}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    providers.find(
                      (p) => p.id === productProvider?.providerId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setProductProvider((prev) => ({
                        ...prev,
                        providerId: newValue.id,
                        name: newValue.name,
                      }));
                    } else {
                      setProductProvider((prev) => ({
                        ...prev,
                        providerId: null,
                        name: "",
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="XML Kaynağı"
                      error={!!formErrors.providerId}
                      helperText={formErrors.providerId}
                      sx={{
                        "& .MuiInputBase-input": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                      }}
                    />
                  )}
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiAutocomplete-inputRoot": {
                      borderRadius: "10px",
                    },
                  }}
                  noOptionsText="XML kaynağı bulunamadı"
                />

                <TextField
                  size="small"
                  label="XML ismi"
                  variant="outlined"
                  value={productProvider.name || ""}
                  fullWidth
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  error={!!formErrors.name}
                  helperText={formErrors.name}
                />
                <TextField
                  size="small"
                  label="XML Kaynak Linki"
                  variant="outlined"
                  value={productProvider.link || ""}
                  fullWidth
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                  onChange={(e) => handleInputChange("link", e.target.value)}
                  error={!!formErrors.link}
                  helperText={formErrors.link}
                />
                <TextField
                  size="small"
                  label="XML Ekstra Notlar"
                  variant="outlined"
                  value={productProvider.note || ""}
                  multiline
                  rows={3}
                  fullWidth
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                  onChange={(e) => handleInputChange("note", e.target.value)}
                />
              </>
            )}

            {activeStep === 1 && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    textAlign: "left",
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                  }}
                >
                  Ürün Ayarları
                </Typography>
                <Alert
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  }}
                  severity="info"
                >
                  Eğer ürün ön eki girmezsseniz veya yeni barkodu aktif etmez
                  iseniz ürünleriniz buybox da listelenebilir.
                </Alert>

                <TextField
                  size="small"
                  label="Ürün kodu ön eki"
                  variant="outlined"
                  value={productProviderGeneralSetting.segmentCode || ""}
                  onChange={(e) =>
                    handleInputChangeProductProviderGeneralSetting(
                      "segmentCode",
                      e.target.value
                    )
                  }
                  fullWidth
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                />

                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3 },
                    mb: { xs: 2, sm: 3 },
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    backgroundColor: "background.paper",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        gutterBottom
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 600,
                        }}
                      >
                        ÜRÜN BARKOLARI GÜNCELLEMESİ YAPILSIN
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          color: "text.secondary",
                        }}
                      >
                        {`Ürünleriniz ${APP_CONFIG.name}'a yüklenirken barkodları`}
                        benzersiz bir şekilde yeniden eklemek istiyorsanız bu
                        seçeneği aktif etmeniz gerekmektedir.
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Ayarı Aç"
                      onChange={(e) =>
                        handleInputChangeProductProviderGeneralSetting(
                          "newBarcode",
                          e.target.checked
                        )
                      }
                      sx={{
                        ml: { xs: 0, sm: 2 },
                        mt: { xs: 1, sm: 0 },
                        alignSelf: { xs: "flex-start", sm: "center" },
                        ".MuiFormControlLabel-label": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                    />
                  </Stack>
                </Paper>

                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3 },
                    mb: { xs: 2, sm: 3 },
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    backgroundColor: "background.paper",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        gutterBottom
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 600,
                        }}
                      >
                        ÜRÜN STOK GÜNCELLEMESİ YAPILSIN
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          color: "text.secondary",
                        }}
                      >
                        {`Ürünleriniz ${APP_CONFIG.name}'a yüklendikten sonra 24`}
                        saatte bir stokları güncellenmemesini istiyorsanız bu
                        seçeneği aktif etmeniz gerekmektedir.
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Ayarı Aç"
                      onChange={(e) =>
                        handleInputChangeProductProviderGeneralSetting(
                          "stokUpdate",
                          e.target.checked
                        )
                      }
                      sx={{
                        ml: { xs: 0, sm: 2 },
                        mt: { xs: 1, sm: 0 },
                        alignSelf: { xs: "flex-start", sm: "center" },
                        ".MuiFormControlLabel-label": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                    />
                  </Stack>
                </Paper>

                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3 },
                    mb: { xs: 2, sm: 3 },
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    backgroundColor: "background.paper",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        gutterBottom
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 600,
                        }}
                      >
                        ÜRÜN FİYAT GÜNCELLEMESİ YAPILSIN
                      </Typography>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                          color: "text.secondary",
                        }}
                      >
                        {`Ürünleriniz ${APP_CONFIG.name}'a yüklendikten sonra 24`}
                        saatte bir fiyatlarının güncellenmemesini istiyorsanız
                        bu seçeneği aktif etmeniz gerekmektedir.
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Ayarı Aç"
                      onChange={(e) =>
                        handleInputChangeProductProviderGeneralSetting(
                          "priceUpdate",
                          e.target.checked
                        )
                      }
                      sx={{
                        ml: { xs: 0, sm: 2 },
                        mt: { xs: 1, sm: 0 },
                        alignSelf: { xs: "flex-start", sm: "center" },
                        ".MuiFormControlLabel-label": {
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                        },
                      }}
                    />
                  </Stack>
                </Paper>

                <TextField
                  size="small"
                  label="Kritik Stok Sınırı"
                  variant="outlined"
                  fullWidth
                  value={productProviderGeneralSetting.stockCritical || ""}
                  onChange={(e) =>
                    handleInputChangeProductProviderGeneralSetting(
                      "stockCritical",
                      e.target.value
                    )
                  }
                  sx={{
                    mb: { xs: 2, sm: 3 },
                    "& .MuiInputBase-input": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                    },
                  }}
                  type="number"
                  error={!!formErrors.stockCritical}
                  helperText={formErrors.stockCritical}
                  inputProps={{
                    min: 0,
                  }}
                />
              </>
            )}

            {activeStep === 2 && (
              <ThemeProvider theme={theme}>
                <Box
                  sx={{
                    p: { xs: 1, sm: 2 },
                    backgroundColor: "background.paper",
                    borderRadius: 2,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                >
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      textAlign: "left",
                      fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                      fontWeight: 600,
                      color: "primary.main",
                    }}
                  >
                    KDV Yapılandırması
                  </Typography>

                  <Alert
                    severity="info"
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      "& .MuiAlert-message": {
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      },
                    }}
                  >
                    KDV oranını manuel olarak belirlemek istiyorsanız "Manuel
                    KDV Oranı" seçeneğini aktif ediniz.
                  </Alert>

                  <Grid
                    container
                    spacing={{ xs: 1, sm: 2 }}
                    sx={{
                      mb: { xs: 2, sm: 3 },
                      display: "flex",
                      justifyContent: { xs: "center", sm: "flex-start" },
                    }}
                  >
                    <Grid item xs={12} sm="auto">
                      <ToggleButton
                        selected={vatConfig === true}
                        onClick={() =>
                          vatConfig == false
                            ? setVatConfig(true)
                            : setVatConfig(false)
                        }
                        sx={{
                          width: { xs: "100%", sm: "auto" },
                          minWidth: { xs: "100%", sm: "180px" },
                          height: { xs: "48px", sm: "50px" },
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 500,
                          borderRadius: "8px",
                          borderWidth: "2px",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            borderWidth: "2px",
                            transform: "translateY(-1px)",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "primary.main",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "primary.dark",
                            },
                          },
                        }}
                      >
                        Manuel KDV Oranı
                      </ToggleButton>
                    </Grid>
                  </Grid>

                  {vatConfig && (
                    <Box
                      sx={{
                        mt: { xs: 2, sm: 3 },
                        p: { xs: 2, sm: 3 },
                        backgroundColor: "grey.50",
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: { xs: 1.5, sm: 2 },
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 500,
                          color: "text.secondary",
                        }}
                      >
                        KDV Oranı Belirleme
                      </Typography>

                      <TextField
                        size="small"
                        type="number"
                        label="KDV Oranı (%)"
                        variant="outlined"
                        value={productProviderGeneralSetting.vatRate || ""}
                        onChange={(e) =>
                          handleInputChangeProductProviderGeneralSetting(
                            "vatRate",
                            e.target.value
                          )
                        }
                        fullWidth
                        sx={{
                          "& .MuiInputBase-input": {
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            height: { xs: "40px", sm: "48px" },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                          },
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                          },
                        }}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            max: 100,
                            step: 1,
                          },
                          endAdornment: (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.secondary",
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                              }}
                            >
                              %
                            </Typography>
                          ),
                        }}
                        helperText="0-100 arasında bir değer giriniz"
                        FormHelperTextProps={{
                          sx: {
                            fontSize: { xs: "0.75rem", sm: "0.875rem" },
                            mx: 0,
                          },
                        }}
                      />
                    </Box>
                  )}

                  <Box
                    sx={{
                      mt: { xs: 2, sm: 3 },
                      p: { xs: 2, sm: 3 },
                      backgroundColor: "grey.50",
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        mb: { xs: 1.5, sm: 2 },
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        fontWeight: 500,
                        color: "text.secondary",
                      }}
                    >
                      Bilgilendirme
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        color: "text.secondary",
                        lineHeight: 1.6,
                      }}
                    >
                      • Manuel KDV oranı belirlemediğiniz takdirde, sistem
                      varsayılan olarak ürünlerinizin mevcut KDV oranlarını
                      kullanacaktır.
                      <br />
                      • Belirlediğiniz KDV oranı, tüm ürünleriniz için geçerli
                      olacaktır.
                      <br />• KDV oranını daha sonra değiştirebilirsiniz.
                    </Typography>
                  </Box>
                </Box>
              </ThemeProvider>
            )}

            {activeStep === 3 && (
              <Card
                elevation={3}
                sx={{
                  margin: "0 auto",
                  p: { xs: 1, sm: 2, md: 3 },
                }}
              >
                <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                    mb={2}
                    gap={1}
                  >
                    <Box display="flex" alignItems="center">
                      <Tooltip title="XML Kaynağı Detayları">
                        <IconButton color="primary" size="small">
                          <InfoOutlinedIcon
                            sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Typography
                        variant="h6"
                        color="primary"
                        ml={2}
                        sx={{
                          fontSize: {
                            xs: "1.1rem",
                            sm: "1.25rem",
                            md: "1.5rem",
                          },
                        }}
                      >
                        XML Kaynağı Detayları
                      </Typography>
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      sx={{
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                      }}
                    >
                      {productProvider?.name || "Belirtilmemiş"}
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: { xs: 2, sm: 3 } }} />

                  <Grid container spacing={{ xs: 1, sm: 2 }}>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                        sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                      >
                        Link
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight="medium"
                        sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                      >
                        {productProvider?.link || "Belirtilmemiş"}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Manuel KDV Oranı
                      </Typography>
                      {renderBooleanValue(
                        productProvider?.productProviderGeneralSetting
                          ?.manuelVatRate
                      )}
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Yeni Barkod
                      </Typography>
                      {renderBooleanValue(
                        productProvider?.productProviderGeneralSetting
                          ?.newBarcode
                      )}
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Fiyat Güncelle
                      </Typography>
                      {renderBooleanValue(
                        productProvider?.productProviderGeneralSetting
                          ?.priceUpdate
                      )}
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Segment Kodu
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {productProvider?.productProviderGeneralSetting
                          ?.segmentCode || "Belirtilmemiş"}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Kritik Stok
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {productProvider?.productProviderGeneralSetting
                          ?.stockCritical || "Belirtilmemiş"}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Stok Güncelle
                      </Typography>
                      {renderBooleanValue(
                        productProvider?.productProviderGeneralSetting
                          ?.stokUpdate
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "flex-end",
                mt: { xs: 2, sm: 3 },
                gap: { xs: 1, sm: 2 },
              }}
            >
              {activeStep !== 0 && (
                <Button
                  variant="outlined"
                  onClick={handleBack}
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    borderRadius: "10px",
                    width: { xs: "100%", sm: "auto" },
                    minWidth: { xs: "100%", sm: "140px" },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    fontWeight: 600,
                    py: { xs: 1.2, sm: 1.5 },
                    px: { xs: 3, sm: 4 },
                    borderColor: "#1565C0",
                    color: "#1565C0",
                    borderWidth: "2px",
                    textTransform: "none",
                    letterSpacing: "0.5px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                      borderColor: "#0D47A1",
                      color: "#0D47A1",
                      backgroundColor: "rgba(21, 101, 192, 0.08)",
                      borderWidth: "2px",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 12px rgba(21, 101, 192, 0.3)",
                    },
                    "&:active": {
                      transform: "translateY(0px)",
                      boxShadow: "0 2px 8px rgba(21, 101, 192, 0.2)",
                    },
                    "& .MuiButton-startIcon": {
                      transition: "transform 0.3s ease",
                    },
                    "&:hover .MuiButton-startIcon": {
                      transform: "translateX(-4px)",
                    },
                  }}
                >
                  Geri
                </Button>
              )}
              {activeStep !== steps.length - 1 ? (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    borderRadius: "10px",
                    width: { xs: "100%", sm: "auto" },
                    minWidth: { xs: "100%", sm: "140px" },
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    fontWeight: 600,
                    py: { xs: 1.2, sm: 1.5 },
                    px: { xs: 3, sm: 4 },
                    background: "linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)",
                    boxShadow: "0 4px 15px rgba(21, 101, 192, 0.4)",
                    textTransform: "none",
                    letterSpacing: "0.5px",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #1976D2 0%, #1565C0 100%)",
                      boxShadow: "0 6px 20px rgba(21, 101, 192, 0.6)",
                      transform: "translateY(-2px)",
                    },
                    "&:active": {
                      transform: "translateY(0px)",
                      boxShadow: "0 2px 10px rgba(21, 101, 192, 0.4)",
                    },
                    "& .MuiButton-endIcon": {
                      transition: "transform 0.3s ease",
                    },
                    "&:hover .MuiButton-endIcon": {
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  İleri
                </Button>
              ) : (
                <Button
                  onClick={handleSubmit}
                  type="submit"
                  variant="contained"
                  startIcon={
                    <IoMdSave
                      sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                    />
                  }
                  sx={{
                    borderRadius: 18,
                    backgroundColor: "#1F1B45",
                    color: "#FFFFFF",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    padding: { xs: "8px 16px", sm: "10px 20px" },
                    width: { xs: "100%", sm: "auto" },
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      backgroundColor: "#2C285A",
                    },
                  }}
                >
                  Kaydet
                </Button>
              )}
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
